rdefine('app/products/components/TabChoiceVariant',['backbone'],function(Backbone) {
    return Backbone.Ribs.View.extend({
        tagName:'li',
        className:'',
        bindings:{
            el:{
                classes:{
                    active:{
                        data:'model.active',
                    }
                }
            },
            'a span':{
                text: {
                    data: 'model.cform',
                    processor: function(name) {
                        var t= (name && name.lang && name.lang[window.currentlang])?name.lang[window.currentlang].name:'';
                        return (t && t.length)?t:'Untitled';
                    }
                }
            },
            'a':{
                classes:{
                    'allowdelete':{
                        data:'model.size',
                        processor:function(s) {
                            return s>1;
                        }
                    }
                }
            }
        },
        events:{
            "click a":"setActive",
            "click a button":"removeMe"
        },
        initialize:function() {
            this.$el.html('<a href="#" class="special-remove"><span></span><button><i class="zmdi zmdi-delete"></i></button></a>');
            this.collection.on("triggchange",function(){
               // alert("test");
                this.updateBindings();
            }.bind(this));
        },
        setActive:function() {
            this.collection.setActive(this.model);
            return false;
        },
        removeMe:function() {
            //add ask
            this.collection.remove(this.model);
            this.collection.checkActive();
            return false;
        }
    });
});